import React from "react";

import Button from "~/ui/button";
import Input from "~/ui/Input";
import { Modal } from "~/ui/legacyFellowIndex";

import styles from "./CreateApiKeyModal.module.css";

interface CreateApiKeyModalProps {
	privileged?: boolean;
	onSubmit: (name: string) => void;
	onClose: () => void;
}

export default function CreateApiKeyModal({ onSubmit, onClose, privileged }: CreateApiKeyModalProps) {
	const [name, setName] = React.useState("");

	const handleNameChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		setName(e.currentTarget.value);
	}, []);

	const handleSubmit = React.useCallback(() => {
		if (name.trim() === "") return;
		onSubmit(name.trim());
		onClose();
	}, [name, onSubmit, onClose]);

	return (
		<Modal onClose={onClose} width="34rem">
			<Modal.Header onClose={onClose}>
				<Modal.Title>Create a new {privileged ? "admin" : ""} API key</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<label className={styles.label}>
					Choose a name to identify this {privileged ? "admin" : ""} API key
					<Input
						autoFocus
						value={name}
						placeholder="API Key Name"
						onChange={handleNameChange}
						maxLength={255}
						name="api_key_name"
					/>
				</label>
			</Modal.Body>
			<Modal.Footer>
				<Button size="normal" variant="secondary" onClick={onClose}>
					Cancel
				</Button>
				<Button size="normal" variant="primary" onClick={handleSubmit} disabled={name.trim() === ""}>
					Generate key
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
